function parsePositiveIntegerString(value) {
    if (typeof value !== 'string' || !/^[1-9]\d*$/.test(value)) {
        return null;
    }
    return Number(value);
}

export default parsePositiveIntegerString;
